/* Version: 3.5.149 */
'use client';
var ACCORDION_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  LEGAL: 'legal'
};

export { ACCORDION_VARIANT };
